import React, {memo} from "react"
import {useHistory} from "react-router-dom"
import "./index.scss"

type Props = {
    icon?: string
    name?: string
    path?: string
}

export const SubMenuComponent = memo(function SubMenuComponent({icon, name, path}: Props) {
    const history = useHistory()

    return (
        <div className="_custom-menu-box" onClick={() => history.push(path)}>
            <div className="_custom-menu-img">
                <img src={icon} alt="img" />
            </div>
            <span>{name}</span>
        </div>
    )
})
